export default "__VITE_ASSET__xGaUlka___"